export const filterAttachmentFormats = (stringsArray) => {
  const attachmentFormats = stringsArray.map((string) => string.split('/')[1].toUpperCase());
  return attachmentFormats.join(', ');
};
